import { Typography, Grid, TableHead, TableCell, TableBody, Table, TableRow } from '@mui/material';
import { WidgetPanel } from './WidgetPanel';
import LoadingSpinner from '../components/LoadingSpinner';
import { gql } from '../__generated__';
import { useQuery } from '@apollo/client/react';
import { numberFormatted } from '../Formatters';

const GET_USER_COUNTS = gql(`
  query GetUserCounts {
    counts: getUserCounts {
      bfsUserData {
        subscription
        name
        licenseCount
        userCount
      }
      bvnUserData {
        subscription
        name
        licenseCount
        userCount
      }
      studentData {
        subscription
        name
        licenseCount
        userCount
      }
      bfsLicensesTotal
      bfsUsersTotal
      licensesTotal
      usersTotal
      studentsTotal
    }
  }
`);

export function UserCounts() {
  const { data } = useQuery<any, any>(GET_USER_COUNTS);

  return (
    <div>
      <WidgetPanel>
        <Grid container>
          <Grid>
            <Typography variant="h5" gutterBottom>
              <span>Totalt antall kunder og brukere</span>
            </Typography>
          </Grid>
        </Grid>

        {!data && <LoadingSpinner />}
        {data && (
          <Table padding="none">
            <TableHead>
              <TableRow>
                <TableCell>Abonnement</TableCell>
                <TableCell align="right">Kunder</TableCell>
                <TableCell align="right">Brukere</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow>
                <TableCell>Bfsprodukter totalt:</TableCell>
                <TableCell align="right">{numberFormatted(data.counts.bfsLicensesTotal)}</TableCell>
                <TableCell align="right">{numberFormatted(data.counts.bfsUsersTotal)}</TableCell>
              </TableRow>
              {data.counts.bfsUserData.map((r, i) => (
                <TableRow key={i}>
                  <TableCell sx={{ paddingLeft: (theme) => (r.subscription === 9 ? theme.spacing(1) : theme.spacing(2)) }}>{r.name}:</TableCell>
                  <TableCell align="right">{numberFormatted(r.licenseCount)}</TableCell>
                  <TableCell align="right">{numberFormatted(r.userCount)}</TableCell>
                </TableRow>
              ))}
              {data.counts.bvnUserData.map((r, i) => (
                <TableRow key={i}>
                  <TableCell>{r.name}:</TableCell>
                  <TableCell align="right">{numberFormatted(r.licenseCount)}</TableCell>
                  <TableCell align="right">{numberFormatted(r.userCount)}</TableCell>
                </TableRow>
              ))}
              <TableRow>
                <TableCell>
                  <span style={{ fontWeight: 'bold' }}>Totalt:</span>
                </TableCell>
                <TableCell align="right">{numberFormatted(data.counts.licensesTotal)}</TableCell>
                <TableCell align="right">{numberFormatted(data.counts.usersTotal)}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={3}>&nbsp;</TableCell>
              </TableRow>
              <TableRow>
                <TableCell colSpan={3}>
                  <span style={{ fontWeight: 'bold' }}>Studenter</span>
                </TableCell>
              </TableRow>
              {data.counts.studentData.map((r, i) => (
                <TableRow key={i}>
                  <TableCell>{r.name}:</TableCell>
                  <TableCell align="right"></TableCell>
                  <TableCell align="right">{numberFormatted(r.userCount)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </WidgetPanel>
    </div>
  );
}
